import { createSlice } from '@reduxjs/toolkit';
import { onGetDocuments } from './listingBatch.action';

const initialState = {
  selectedStores: [],
  isInactiveChannelEnabled: false,
  allChannels: true,
  channels: [],
  currentDocumentDetail: {},
  pageSize: 20,
  pageNumber: 1
};

export const listingBatchSlice = createSlice({
  name: 'listingBatch',
  initialState,
  reducers: {
    setAppliedStoredFilter: (state, action) => {
      state.selectedStores = action.payload.selectedStores || [];
      state.isInactiveChannelEnabled = action.payload.isInactiveChannelEnabled || false;
      state.allChannels = action.payload.allChannels ?? true;
      state.channels = action.payload.channels || [];
      if (action.payload.eBayCustomer !== undefined) {
        state.eBayCustomer = action.payload.ebayCustomer;
      }
    },
    setPageNumberAndPageSize: (state, action) => {
      state.pageNumber = action.payload.pageNumber || state.pageNumber || 1;
      state.pageSize = action.payload.pageSize || state.pageSize || 20;
    }
  },
  extraReducers: builder => {
    builder.addCase(onGetDocuments.pending, state => {
      state.currentDocumentDetail = { loading: true, error: false, data: [] };
    });
    builder.addCase(onGetDocuments.fulfilled, (state, action) => {
      state.currentDocumentDetail = { loading: false, error: false, data: action.payload?.result };
    });
    builder.addCase(onGetDocuments.rejected, state => {
      state.currentDocumentDetail = { loading: false, error: true, data: [] };
    });
  }
});

export const { setAppliedStoredFilter, setPageNumberAndPageSize } = listingBatchSlice.actions;

export default listingBatchSlice.reducer;
